import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

const ACCENT = "#C67B5C"
const GRID = "#EDE7DC"
const MUTED = "#7A7570"

export default class extends Controller {
  static targets = ["canvas"]
  static values = { points: Array, labels: Array }

  connect() {
    this.chart = new Chart(this.canvasTarget, {
      type: "line",
      data: {
        labels: this.labelsValue,
        datasets: [
          {
            data: this.pointsValue,
            borderColor: ACCENT,
            backgroundColor: "rgba(198, 123, 92, 0.15)",
            borderWidth: 2.5,
            tension: 0.35,
            fill: true,
            pointRadius: 3,
            pointBackgroundColor: "#fff",
            pointBorderColor: ACCENT,
            pointBorderWidth: 2,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          decimation: { enabled: true, algorithm: "lttb" },
          tooltip: {
            callbacks: {
              label: (ctx) => `${(ctx.parsed.y / 1000).toFixed(1)}t`,
            },
          },
        },
        scales: {
          x: { grid: { display: false }, ticks: { maxTicksLimit: 5, color: MUTED, font: { size: 10 } } },
          y: {
            grid: { color: GRID },
            ticks: { color: MUTED, font: { size: 10 }, callback: (v) => `${(v / 1000).toFixed(0)}t` },
          },
        },
      },
    })
  }

  disconnect() {
    this.chart?.destroy()
  }
}
